import Vue from 'vue'
import ToastComponent from '../components/Toast.vue'

/**
 * Toast插件
 * 提供全局的toast功能，可以通过this.$toast调用
 */
class ToastPlugin {
  constructor() {
    this.instance = null // Toast组件实例
    this.container = null // Toast容器DOM元素
  }
  
  /**
   * 初始化Toast实例
   */
  init() {
    if (this.instance) {
      return this.instance
    }
    
    // 创建Toast组件构造器
    const ToastConstructor = Vue.extend(ToastComponent)
    
    // 创建组件实例
    this.instance = new ToastConstructor()
    
    // 挂载组件
    this.instance.$mount()
    
    // 将组件DOM添加到body
    document.body.appendChild(this.instance.$el)
    
    return this.instance
  }
  
  /**
   * 显示toast
   * @param {string} message - 要显示的消息
   * @param {number} duration - 显示时长，默认2000ms
   */
  show(message, duration = 2000) {
    const instance = this.init()
    instance.show(message, duration)
  }
  
  /**
   * 隐藏toast
   */
  hide() {
    if (this.instance) {
      this.instance.hide()
    }
  }
  
  /**
   * 销毁toast实例
   */
  destroy() {
    if (this.instance) {
      this.instance.$destroy()
      if (this.instance.$el && this.instance.$el.parentNode) {
        this.instance.$el.parentNode.removeChild(this.instance.$el)
      }
      this.instance = null
    }
  }
}

// 创建全局Toast实例
const toast = new ToastPlugin()

/**
 * Vue插件安装函数
 * @param {Vue} Vue - Vue构造函数
 */
const install = function(Vue) {
  // 在Vue原型上添加$toast方法
  Vue.prototype.$toast = {
    /**
     * 显示toast消息
     * @param {string} message - 消息内容
     * @param {number} duration - 显示时长
     */
    show(message, duration) {
      toast.show(message, duration)
    },
    
    /**
     * 隐藏toast
     */
    hide() {
      toast.hide()
    }
  }
}

// 自动安装插件（如果在浏览器环境且Vue可用）
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

export default {
  install,
  toast
}


// WEBPACK FOOTER //
// ./src/plugins/toast.js